import React from 'react';
import { Tooltip, Chip, Box } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PersonIcon from '@mui/icons-material/Person';
import GavelIcon from '@mui/icons-material/Gavel';
import BlockIcon from '@mui/icons-material/Block';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';

interface CancellationReasonIconProps {
  reason?: string;
  status?: string;
  cancellationCommissionRate?: number;
}

/**
 * Виджет иконки причины отмены заказа
 */
export const CancellationReasonIcon: React.FC<CancellationReasonIconProps> = ({
  reason,
  status,
  cancellationCommissionRate,
}) => {
  if (!reason && !status) {
    return null;
  }

  const reasonLower = reason?.toLowerCase() || '';
  
  // Определение типа отмены
  let icon: React.ReactNode;
  let color: string;
  let label: string;
  let tooltip: string;

  if (reasonLower.includes('таймаут') || reasonLower.includes('timeout')) {
    // Отмена по таймауту
    icon = <AccessTimeIcon />;
    color = 'error';
    label = 'Timeout';
    tooltip = 'Order cancelled by timeout';
  } else if (reasonLower.includes('клиент') || reasonLower.includes('customer')) {
    // Отмена клиентом
    icon = <PersonIcon />;
    color = cancellationCommissionRate && cancellationCommissionRate > 0 ? 'warning' : 'info';
    label = 'Client';
    tooltip = cancellationCommissionRate && cancellationCommissionRate > 0
      ? `Cancelled by client (commission: ${(cancellationCommissionRate * 100).toFixed(0)}%)`
      : 'Cancelled by client (no commission)';
  } else if (reasonLower.includes('исполнитель') || reasonLower.includes('performer')) {
    // Отмена исполнителем
    icon = <GavelIcon />;
    color = 'warning';
    label = 'Performer';
    tooltip = 'Cancelled by performer';
  } else if (reasonLower.includes('админ') || reasonLower.includes('admin')) {
    // Отмена администратором
    icon = <BlockIcon />;
    color = 'error';
    label = 'Admin';
    tooltip = 'Cancelled by admin';
  } else if (reasonLower.includes('автоматическ') || reasonLower.includes('auto')) {
    // Автоматическая отмена
    icon = <ErrorIcon />;
    color = 'error';
    label = 'Auto';
    tooltip = 'Automatic cancellation';
  } else {
    // Другая причина
    icon = <WarningIcon />;
    color = 'default';
    label = 'Cancelled';
    tooltip = reason || 'Order cancelled';
  }

  // Показываем только иконку с tooltip (без отдельного Chip)
  // Chip со статусом уже отображается в OrderCard
  return (
    <Tooltip title={tooltip} arrow>
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          ml: 0.5,
          color: color === 'error' ? '#f44336' : color === 'warning' ? '#ff9800' : '#9e9e9e',
        }}
      >
        {icon}
      </Box>
    </Tooltip>
  );
};

export default CancellationReasonIcon;
